import { render, staticRenderFns } from "./paper-move-to-folder.html?vue&type=template&id=a6468200&scoped=true&external"
import script from "./paper-move-to-folder.js?vue&type=script&lang=js&external"
export * from "./paper-move-to-folder.js?vue&type=script&lang=js&external"
import style0 from "./paper-move-to-folder.scss?vue&type=style&index=0&id=a6468200&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6468200",
  null
  
)

export default component.exports